export default [
  {
    title: 'language',
    dataIndex: 'locale',
    key: 'locale',
  },
  {
    title: 'content',
    dataIndex: 'content',
    key: 'content',
  },
  {
    title: 'type',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'departure_station',
    dataIndex: 'start_station',
    key: 'start_station',
  },
  {
    title: 'arrival_station',
    dataIndex: 'end_station',
    key: 'end_station',
  },
  {
    title: 'delete',
    dataIndex: 'delete',
    key: 'delete',
  },
];
